<template>
  <v-container fluid fill-height>
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar color="#eee" class="elevation-0 secondary--text" style="background: transparent">
          <v-toolbar-title>Minhas Faturas</v-toolbar-title>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <template v-for="(filter, index) in filters">
          <v-btn
            :key="index"
            outline
            round
            :color="filter.color"
            :disabled="selected_filter === filter.value"
            @click="selected_filter = filter.value"
          >{{filter.text}}</v-btn>
        </template>
        <v-list class="mt-3">
          <v-list-tile v-if="!loading && !faturas.length">
            <v-list-tile-content class="headline font-weight-light">
              <v-list-tile-title class="text-xs-center">Nenhuma fatura para mostrar</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-subheader v-if="!loading && faturas.length">
            Clique para mostrar detalhes
          </v-subheader>
          <template v-if="!loading && faturas.length">
            <template v-for="(fatura, index) in faturas">
              <v-list-tile avatar :key="index" ripple class="mb-2">
                <v-list-tile-avatar  @click="detalhar(fatura)">
                  <v-icon color="green">assignment</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content  @click="detalhar(fatura)">
                  <v-list-tile-title>Fatura do dia {{fatura.data_fatura.split('-').reverse().join('/')}}</v-list-tile-title>
                  <v-list-tile-sub-title>Valor: {{fatura.valor_faturamento | currency}}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-list-tile-action-text v-if="!fatura.fatura_paga" class="text-xs-center mb-2" style="width: 100%;">
                    <v-tooltip left>
                      <v-btn slot="activator" icon color="primary" @click="dialogInserirComprovante(fatura)">
                        <v-icon>receipt</v-icon>
                      </v-btn>
                      <span>Anexar comprovante</span>
                    </v-tooltip>
                  </v-list-tile-action-text>
                  <v-list-tile-action-text
                    class="red--text font-weight-bold"
                    v-if="!fatura.fatura_paga"
                  >Pagamento Pendente</v-list-tile-action-text>
                  <template v-else>
                    <v-list-tile-action-text class="green--text font-weight-bold">Pagamento Efetuado</v-list-tile-action-text>
                    <v-list-tile-action-text
                      class="font-weight-bold"
                    >Pago em {{fatura.data_hora_pagamento.substr(0, 10).split('-').reverse().join('/')}}</v-list-tile-action-text>
                  </template>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </template>
        </v-list>
        <v-footer
        dark
          height="auto"
        >
          <v-card
            class="flex"
            flat
            tile
          >
            <v-card-actions class="primary darken-3 justify-center">
              <strong>Banco do Brasil</strong>&nbsp;- Ag.<strong>1668-3</strong>, C.C. <strong>56373-0</strong>
            </v-card-actions>
          </v-card>
        </v-footer>
      </v-flex>
      <v-dialog width="550" v-model="mostrando_detalhes">
        <detalhes-fatura :fatura="fatura_selecionada"></detalhes-fatura>
      </v-dialog>
      <v-dialog width="500" v-if="dialogAnexar" v-model="dialogAnexar">
        <dialog-anexar-comprovante
          :fatura="fatura_selecionada"
          @fechar="dialogAnexar=false"
          @error="snackbarError"
          @success="snackbarSuccess"
        />
      </v-dialog>
        <v-snackbar
          v-model="snackbar.ativo"
          :color="snackbar.color"
          :timeout="4000"
          :vertical="true"
        >
          {{snackbar.text}}
          <v-spacer></v-spacer>
        <v-btn @click="snackbar.active = false" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
import DetalhesFatura from '@/components/dialogs/DetalhesFatura'
import DialogAnexarComprovante from '@/components/dialogs/DialogAnexarComprovante'

export default {
  components: {
    DetalhesFatura,
    DialogAnexarComprovante
  },
  data () {
    return {
      selected_filter: 'pendentes',
      mostrando_detalhes: false,
      dialogAnexar: false,
      fatura_selecionada: null,
      filters: [
        {
          text: 'Pendentes',
          value: 'pendentes',
          color: 'green'
        },
        {
          text: 'Pagas',
          value: 'pagas',
          color: 'blue'
        },
        {
          text: 'Todas',
          value: 'todas',
          color: 'red'
        }
      ],
      snackbar: {
        ativo: false,
        color: 'info',
        text: ''
      }
    }
  },
  watch: {
    ready (val) {
      if (val) {
        this.listarFaturas()
      }
    },
    selected_filter (val) {
      if (val && this.ready) {
        this.listarFaturas()
      }
    }
  },
  mounted () {
    if (this.ready) {
      this.listarFaturas()
    }
  },
  computed: {
    filtros () {
      let tempFiltros = {}
      switch (this.selected_filter) {
        case 'pendentes':
          tempFiltros['fatura_paga'] = false
          break
        case 'pagas':
          tempFiltros['fatura_paga'] = true
          break
      }
      return tempFiltros
    },
    loading () {
      return this.$store.getters.loading
    },
    faturas () {
      return this.$store.getters.faturas
    },
    headers () {
      return this.$store.getters.headers
    },
    posto () {
      return this.$store.getters.posto
    },
    ready () {
      return !!this.posto && !!this.headers
    }
  },
  methods: {
    listarFaturas () {
      this.$store.dispatch('listarFaturas', this.filtros)
    },
    detalhar (fatura) {
      this.fatura_selecionada = fatura
      this.mostrando_detalhes = true
    },
    dialogInserirComprovante (fatura) {
      this.fatura_selecionada = fatura
      this.dialogAnexar = true
    },
    snackbarError (erro) {
      this.snackbar.color = 'error'
      this.snackbar.text = erro
      this.snackbar.ativo = true
    },
    snackbarSuccess (text) {
      this.listarFaturas()
      this.snackbar.color = 'primary'
      this.snackbar.text = text
      this.snackbar.ativo = true
    }
  }
}
</script>
